import { Component, OnInit } from '@angular/core';
import { DynamicCardType } from 'src/app/common/components/dynamic-form-v2/enums/DynamicCardType';
import { DynamicViewType } from 'src/app/common/components/dynamic-view-v2/enums/DynamicViewType';
import { BaseDynamicViewComponent } from 'src/app/common/components/dynamic-view-v2/components/base-dynamic-form/base-dynamic-view.component';
import { BaseViewFieldType } from 'src/app/common/components/dynamic-view-v2/enums/BaseViewFieldType';

@Component({
  selector: 'app-mystery-box-content-view',
  templateUrl: './mystery-box-content-view.component.html',
  styleUrls: ['./mystery-box-content-view.component.sass']
})
export class MysteryBoxContentViewComponent extends BaseDynamicViewComponent implements OnInit {

  mysteryBoxContentRecord: any = {};
  
  constructor() {
    super();
  }

  ngOnInit() {
    this.fields = [
      {
        title: "Mystery Box Content Data",
        fields: [
          {
            name: "Name",
            inputType: DynamicViewType.BaseViewField,
            viewTypes: [BaseViewFieldType.Text],
            clearField: true,
            key: 'name',
            label: 'Name',
            columnWidth: 6
          },
          {
            name: "Description",
            inputType: DynamicViewType.BaseViewField,
            viewTypes: [BaseViewFieldType.Text],
            clearField: true,
            key: 'description',
            label: 'Description',
            columnWidth: 6
          },
          {
            name: "Entry Type",
            inputType: DynamicViewType.BaseViewField,
            viewTypes: [BaseViewFieldType.Text],
            clearField: true,
            key: 'entryType',
            label: 'Entry Type',
            columnWidth: 6
          },
          {
            name: "Weight",
            inputType: DynamicViewType.BaseViewField,
            viewTypes: [BaseViewFieldType.Text],
            clearField: true,
            key: 'weight',
            label: 'Weight',
            columnWidth: 6
          },
          {
            name: "Line Item",
            inputType: DynamicViewType.Price,
            clearField: true,
            key: 'lineItem',
            label: 'Line Item',
            columnWidth: 12
          },
          {
            name: "Item Collection",
            inputType: DynamicViewType.MiscRef,
            clearField: true,
            key: 'itemCollectionRef',
            label: 'Item Collection',
            controller: 'collections',
            columnWidth: 6
          },
          {
            name: "Item Reward Quantity",
            inputType: DynamicViewType.BaseViewField,
            viewTypes: [BaseViewFieldType.Text],
            clearField: true,
            key: 'itemRewardQuantity',
            label: 'Item Reward Quantity',
            columnWidth: 6
          },
          {
            name: "Coin Weight",
            inputType: DynamicViewType.MiscRef,
            clearField: true,
            key: 'coinWeight',
            label: 'Coin Weight',
            controller: 'nurture-rarity',
            columnWidth: 3
          },
          {
            name: "Diamond Weight",
            inputType: DynamicViewType.MiscRef,
            clearField: true,
            key: 'diamondWeight',
            label: 'Diamond Weight',
            controller: 'nurture-rarity',
            columnWidth: 3
          }
        ],
        type: DynamicCardType.Card
      }
    ];

    this.title = "Mystery Box Content";
    this.viewRoute = 'mystery-box-content';
    this.isLoading = false;
  }
}

